<template>
  <div class="mutation-main">
    <div @scroll="scrollChange" class="mutation-list" ref="scrollView">
      <div class="title">
        <span>突变1</span>
        <span>突变2</span>
        <span style="min-width: 80px">检出状态</span>
        <span>临床意义</span>
      </div>
      <div class="show-box"></div>
      <div class="list">
        <span>TP53</span>
        <span>EGFR</span>
        <span class="tags"><i>无共突变</i></span>
        <span>预后/耐药</span>
      </div>
      <div class="list">
        <span>TP53</span>
        <span>EGFR</span>
        <span class="tags"><i>未检出突变</i></span>
        <span>预后/耐药</span>
      </div>
      <div class="list">
        <span>TP53</span>
        <span>EGFR</span>
        <span class="tags"
          ><i
            :style="{
              color: '共突变' ? '#FF627F' : '',
              background: '共突变' ? '#FFECEF' : '',
            }"
            >共突变</i
          ></span
        >
        <span>预后/耐药</span>
      </div>
    </div>
    <div class="page">
      <p :class="{ active: isActive }"></p>
      <p :class="{ active: isTwo }"></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isActive: true,
      isTwo: false,
    };
  },
  mounted() {},
  methods: {
    scrollChange(e) {
      const scrollLeft = e.target.scrollLeft;
      const scrollW = e.target.scrollWidth;
      const W = this.$refs.scrollView.clientWidth;
      if (scrollW - W === scrollLeft) {
        this.isActive = false;
        this.isTwo = true;
      } else {
        this.isActive = true;
        this.isTwo = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  width: 121%;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.mutation-main {
  font-family: @family;
  background: #F4F8FD ;
  border-radius: 10px;
  padding-bottom: 30px;
  margin-bottom: 22px;
    position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background: #F4F8FD;
    opacity: 0.3;
  }
  .page {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    padding-right: 24px;
    .active {
      background: #2f354d;
    }
    p {
      width: 6px;
      height: 6px;
      background: #d4d6dd;
      border-radius: 6px;
      margin-left: 12px;
    }
  }
  .mutation-list {
    overflow-x: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-y: hidden;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .title {
      height: 48px;
      padding: 0 24px;
      box-sizing: border-box;
      width: 121%;
      font-size: 15PX;
      font-weight: 500;
      color: #9095a7;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        min-width: 70px;
      }
    }
    .list {
      width: 121%;
      height: 48px;
      padding: 0 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 15PX;
      font-weight: 400;
      color: #2f354d;
      line-height: 22px;
      .tags {
        min-width: 80px;
        i {
          font-style: normal;
          border-radius: 4px;
          padding: 1px 3px;
          color: #5f697d;
          background: #ebeff7;
        }
      }
      span {
        min-width: 70px;
      }
    }
  }
}
</style>
